import { useLayoutEffect, useRef, useState, type ComponentProps, type CSSProperties, type ReactNode } from "react";
import { viewportLayout, type ViewportGeometry } from "./use-visual-viewport";
import "./game-layout.css";

interface AreaStyle extends CSSProperties {
  "--play-area-width": string;
  "--play-area-height": string;
}
export function GameLayout({ viewport, chat, children, ...attributes }: Omit<ComponentProps<"main">, "style" | "className"> & {
  viewport: ViewportGeometry;
  chat?: ReactNode;
}) {
  const main = useRef<HTMLDivElement>(null);
  const [area, setArea] = useState(viewport);
  useLayoutEffect(() => {
    const node = main.current;
    if (!node) return;
    const resize = () => setArea(previous => previous.width === node.clientWidth && previous.height === node.clientHeight
      ? previous : { width: node.clientWidth, height: node.clientHeight, left: 0, top: 0 });
    resize();
    const observer = new ResizeObserver(resize);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  const areaStyle: AreaStyle = { "--play-area-width": `${area.width}px`, "--play-area-height": `${area.height}px` };
  return <main {...attributes} className="game-shell game-layout" data-chat-open={Boolean(chat)} data-viewport-layout={viewportLayout(area)}
    style={{ width: viewport.width, height: viewport.height, left: viewport.left, top: viewport.top }}>
    <div className="game-main" ref={main} style={areaStyle}>{children}</div>
    {chat && <aside className="game-chat" aria-label="Область чата">{chat}</aside>}
  </main>;
}
